module.exports = __webpack_public_path__ + "img/85.5835f161.jpg";